import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useMercuryCenterAnalytics } from "./mercury-center_analytics";
import { generalInfo, partnerConfig } from "./mercury-center_partner_config";

const Theme = lazyWithRetry(() => import("./mercury-center_theme"));

const faqs = [
  {
    question: "Tell me more about your conference rooms",
    answer:
      "The conference room is equipped with a 80” TV, suitable for making high resolution presentations.  Members can connect their laptop directly to our portal and begin making the presentation.  Our HD wide angle webcam has a zoomable autofocus lens which will track the speaker and automatically zoom in to enlarge the image.  The 360-degree conference microphone can capture sounds from all corners of the room.",
  },
];

export function OfferingMercuryCenterMeetingRoom() {
  useMercuryCenterAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
